import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/about-restaurant/components/CustomerTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/about-restaurant/components/HygieneQuality.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/home-landing/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/NavigationBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/AppImage.tsx");
